import React from "react";
import {Card, CardBody, CardHeader, CardTitle, Table} from "reactstrap";
import { SketchPicker } from 'react-color';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class TeamTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: "",
            value: '#FFFFFF',
            modalOpen: false
        }
    }

    toggleOpen = (index) => {
        this.setState({modalOpen: !this.state.modalOpen, open: index});
    }

    colourChange = (c) => {
        this.setState({value: c.hex});
    }

    saveState = () => {
        //loop through the reps
        //find teh name and set the colour
        var id = 0;
        var r = this.props.data.filter(r => r.ExternalUserID == this.state.open);
        if (r.length > 0) {
            id = r[0].ExternalUserID;
        }
        this.setState({modalOpen: false})
        if (this.props.onColourSave) {
            this.props.onColourSave(id, this.state.value);
        }
    }

    getUserName = (userID) => {
        var r = this.props.data.filter(r => r.ExternalUserID == this.state.open);
        if (r.length > 0) {
            return r[0].UserName;
        }
        return '';
    }


    //TODO add a modal that has the colour picker in it
    //show the username of the person we are choosing the colour for
    //have a close button
    //add a save button to the team area
    render() {
        const {tableName, data} = this.props;
        const {modalOpen} = this.state;
        return (
            <>
                <Card>
                    <CardHeader>
                        <CardTitle tag="h4">{tableName}</CardTitle>
                    </CardHeader>
                    <CardBody>
                        <Table className="tablesorter" responsive>
                            <thead className="text-primary">
                            <tr>
                                <th>Employee</th>
                                <th className={`text-center`}>View in Pipedrive</th>
                                <th className={`text-center`}>&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            { data.map(d => {
                              return(

                                  <tr>
                                      <td>{d.UserName}</td>
                                      <td className={`text-center`}><a href={`https://instylesolar3.pipedrive.com/users/details/`+d.ExternalUserID}>Pipedrive</a></td>
                                      <td>
                                          <div onClick={() => this.toggleOpen(d.ExternalUserID)} className={`text-center`}>
                                              {
                                                  (d.Color == '#000000' || d.Color.length == 0)  && 'Pick Colour'
                                              }
                                              {
                                                  d.Color != '#000000' && <div className={`person--colour-box`} style={{backgroundColor: d.Color}}></div>
                                              }
                                          </div>
                                      </td>
                                  </tr>
                              )
                            })}
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
                <Modal isOpen={modalOpen} toggle={() => this.toggleOpen("")}>
                    <ModalHeader toggle={() => this.toggleOpen("")}>Colour for {this.getUserName(this.state.open)}</ModalHeader>
                    <ModalBody>
                        <div>
                            <SketchPicker
                                color={this.state.value}
                                onChangeComplete={this.colourChange}
                            disableAlpha={true}/>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.saveState}>Save</Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}

export default TeamTable;